var React = require('react');

function PlanFree (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.225 87.5L48 29L81.775 87.5H14.225Z","fill":"black","stroke":"black","strokeWidth":"5","key":0}),React.createElement("path",{"d":"M31.225 77.5L65 19L98.775 77.5H31.225Z","fill":"white","stroke":"black","strokeWidth":"5","key":1}),React.createElement("path",{"d":"M65 42L79.7224 67.5H50.2776L65 42Z","fill":"black","key":2})]);
}

PlanFree.defaultProps = {"width":"112","height":"112","viewBox":"0 0 112 112","fill":"none"};

module.exports = PlanFree;

PlanFree.default = PlanFree;
